/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HelpEndpointResponse
 */
export interface HelpEndpointResponse {
    /**
     * 
     * @type {string}
     * @memberof HelpEndpointResponse
     */
    page: string;
}

export function HelpEndpointResponseFromJSON(json: any): HelpEndpointResponse {
    return HelpEndpointResponseFromJSONTyped(json, false);
}

export function HelpEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HelpEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
    };
}

export function HelpEndpointResponseToJSON(value?: HelpEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
    };
}


